import React from "react";
import { View, StyleSheet } from "react-native";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";

const ResetAccountConfirmationModal = ({ visible, onClose }) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose}>
      <View style={styles.container}>
        <CustomText text="Your account has been cleared and reset." size="m" textAlign="center" />
        <CustomButton text="Close" onPress={onClose} styleType="primary" />
      </View>
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    alignItems: "center",
  },
});

export default ResetAccountConfirmationModal;
